import React from "react"
import defalutStyle from "../../../../styles/defaultPageStyle.module.css"
import { TitlePageResponsiveIconSmall } from "../../../../components/Titles/Titles"
import { ButtonIcon } from "../../../../components/Button/Button"
import { faClose, faUser } from "@fortawesome/free-solid-svg-icons"
import { type ListItem } from "../../../../components/List/List"
import { SIZE } from "../../../../configuration/Sizes"
import THEME from "../../../../configuration/Theme"
import Animate, { AnimationTypes } from "../../../../components/Animate/Animate"
import { ListAddCustomers } from "../../../../components/ListAddCostumers/ListAddCustomers"
import { useTranslation } from "react-i18next"

export interface CostumerListProbs {
  listCards: ListItem[]
  onClinck: (e: number) => void
  onClonse: () => void
  includeDefaultCustomer?: boolean
}

export const CostumerList: React.FC<CostumerListProbs> = ({ onClinck, onClonse, includeDefaultCustomer = true }) => {
  const { t } = useTranslation("customer")

  return (
    <div className={defalutStyle.overlay}>
      <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
        <div className={defalutStyle.alert1}>
          <TitlePageResponsiveIconSmall
            title={t("label_find_and_insert_customer")}
            icon={faUser}
            children={
              <ButtonIcon
                sizeNumber={SIZE.buttonCloseIconSize}
                bgColor={THEME.colors.buttonBGCloseColor}
                iconColor={THEME.colors.buttonFGCloseColor}
                icon={faClose}
                onClick={onClonse}
                size="small"
                descriptionKey="interactionDescriptions:pages.fluxo.order.components.customerList.button.onClonse"
              />
            }
          />

          <ListAddCustomers handleOnClick={(e) => onClinck(e)} includeDefaultCustomer={includeDefaultCustomer} />
        </div>
      </Animate>
    </div>
  )
}
